import { AdminBondFormSection } from "@portal/components/features/bond-form";
import { ReportedRetryableLoadError } from "@portal/components/features/load-errors";
import { Spinner, Text } from "@portal/components/primitives";
import type { FC } from "react";
import { AdminBondRequestBondFormCard } from "../../../shared/AdminBondRequestBondFormCard";
import type { BondRequestTabProps } from "../types";

export const AdminBondRequestBondFormTab: FC<BondRequestTabProps> = ({
	request,
	bondFormQuery,
}) => {
	const { data: bondForm, error, isFetching, isLoading, refetch } = bondFormQuery;

	if (error) {
		return (
			<ReportedRetryableLoadError
				error={error}
				resource="bond form"
				onRetry={() => refetch()}
				retrying={isFetching}
				testId="bond-form-load-error"
			/>
		);
	}

	if (isLoading) {
		return (
			<div
				data-testid="loading-error-display-loading"
				className="flex w-full p-4 justify-center items-center gap-2"
			>
				<Spinner />
				<Text type="body" color="secondary">
					Loading bond form…
				</Text>
			</div>
		);
	}

	return (
		<div className="flex flex-col space-y-[40px]" data-testid="admin-bond-request-bond-form-tab">
			{bondForm ? (
				<>
					<AdminBondFormSection request={request} bondForm={bondForm} />
					<AdminBondRequestBondFormCard request={request} bondForm={bondForm} />
				</>
			) : null}
		</div>
	);
};
